var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 830,
    height: 830,
    viewBox: "0 0 830 830",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.542 138.665L654.506 278.323L652.541 554.235L412.612 690.489L174.648 550.831L176.613 274.92L416.542 138.665Z",
    stroke: "#FFE713",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431.116 136.841L663.373 290.033L646.833 567.769L398.037 692.313L165.78 539.122L182.32 261.385L431.116 136.841Z",
    stroke: "#FFBD13",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.409 137.098L641.297 252.309L668.464 529.788L441.745 692.056L187.857 576.844L160.689 299.365L387.409 137.098Z",
    stroke: "#FF7F38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M397.182 137.472L645.86 260.96L663.255 538.065L431.972 691.683L183.294 568.194L165.899 291.089L397.182 137.472Z",
    stroke: "url(#paint0_linear_79_255)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_255",
    x1: 274.573,
    y1: 218.134,
    x2: 519.736,
    y2: 632.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8139"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern1);
export default __webpack_public_path__ + "static/media/pattern1.6a4cbc7a9a2de472addd03b1a6d014b1.svg";
export { ForwardRef as ReactComponent };